<template>
  <footer class="footer">
    © 2021 PT Lingkar Sembilan Titian Media
  </footer>
</template>
<script>
export default {
  
}
</script>